/* eslint-disable react/jsx-no-constructed-context-values */
import * as React from 'react';
import { ProgressIndicator } from '@oneaudi/unified-web-components';
import { Partner } from '@oneaudi/audi-partner-utils';
import { useQuery } from '@apollo/client';
import { useTrackingManager } from '../../../hooks/useTrackingManager';
import { PartnerBusinessCardFixedNarrow } from './PartnerBusinessCardFixedNarrow';
import { queryString } from '../../../query';
import { createPartner } from './PartnerData';
import { PartnerBusinessCardProps, PartnerBusinessCardPropsConfig } from './pbc-types';
import { PartnerContext } from '../../../contexts/partner-context';
import mapContext from '../../../contexts/map-context';
import { pruneOpeningHours } from '../../../utils/use-partner-data';

export interface ConfigProps {
  partnerID: string;
  locale?: string;
}
export const PartnerBusinessCard = (
  props: PartnerBusinessCardProps,
): React.ReactElement | undefined => {
  const trackingManager = useTrackingManager();
  const { partnerID, config } = props;

  const mapState = mapContext.useMapState();

  if (!partnerID) {
    // eslint-disable-next-line no-console
    console.debug('"partnerID" is missing! Partner data will not be fetched');
    // TODO Refactor component to render variants depending on partnerID is defined or not
  }

  const [fetchedPartnerData, setFetchedPartnerData] = React.useState<Partner | undefined>();

  // const pssEndpointUrl = mapState.devMode ? urlConfig.graphqlUrlDev : urlConfig.graphqlUrlProd;

  const { data } = useQuery(queryString, {
    variables: { partnerId: partnerID },
    fetchPolicy: 'no-cache',
  });

  if (data) {
    const { dealerById } = data;
    if (dealerById?.openingHours) {
      dealerById.openingHours = pruneOpeningHours(dealerById.openingHours);
    }
  }

  const partner = createPartner(fetchedPartnerData);
  const partnerHasOpeningHours = !!(
    partner &&
    partner?.openingHours?.departments &&
    partner.openingHours?.departments?.length > 0
  );

  const pbcPropsConfig: PartnerBusinessCardPropsConfig = {
    ...config,
    ...mapState?.fiveStarData,
  };

  React.useEffect(() => {
    if (data) {
      setFetchedPartnerData(data.dealerById);
    }
  }, [data]);
  React.useEffect(() => {
    trackingManager?.pageLoad('fixed-narrow', partnerID);
  }, [partnerID, trackingManager]);
  return !fetchedPartnerData ? (
    <div style={{ textAlign: 'center' }}>
      <ProgressIndicator variant="bar" data-test-id="loader-component" type="infinite" size="md" />
    </div>
  ) : (
    partner && (
      <PartnerContext.Provider value={{ partner, partnerHasOpeningHours }}>
        <PartnerBusinessCardFixedNarrow {...pbcPropsConfig} />
      </PartnerContext.Provider>
    )
  );
};
